"use client";

import { FormattedMessage } from "react-intl";

const Copyright = () => {
  return (
    <>
      <div className="mt-8 border-t border-gray-200 pt-8 lg:flex lg:items-center lg:justify-between">
        <div className="text-gray-400 text-xs pt-1">
          <p>
            <FormattedMessage
              defaultMessage={
                "Copyright © 2025 Logiciel, Inc. All rights reserved."
              }
              id="footer.tab.finalCopyright"
            />
          </p>
        </div>
      </div>
    </>
  );
};

export default Copyright;
